import * as classnames from 'classnames/bind'
import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Link } from 'react-router-dom'
import BasicLayout from '../../layouts/BasicLayout'
import styles from './payment-success-page.scss'


const cx = classnames.bind({ ...styles })

interface IProps extends RouteComponentProps<any> { }

class PaymentSuccessPage extends React.Component<IProps> {

  public componentDidMount = () => {
    setTimeout(() => this.props.history.push('/'), 5000)
  }
  public render() {
    return (
      <div style={{ zIndex: 10 }}>
        <BasicLayout noFooter={true}>
          <div className={cx('wrapper', 'expert-page')}>
            {/* <!-- Start main --> */}
            <section className={cx('main')}>

              <main className={cx('g-height-100x', 'g-min-height-100vh', 'g-flex-centered', 'g-pa-15')}>
                <div className={cx('text-center', 'g-flex-centered-item', 'g-position-rel')}>
                  <div className={cx('g-absolute-centered', 'g-font-size-80', 'g-font-size-120--sm', 'g-font-size-420--lg', 'g-line-height-1', 'g-font-weight-200', 'g-color-gray-dark-v2', 'g-opacity-0_1')} />

                  <div className={cx('g-absolute-centered')}>
                    <p className={cx('g-color-black-opacity-0_6', 'g-font-size-24')}>購買成功</p>
                    <br />
                    <p className={cx('g-color-black-opacity-0_6', 'g-font-size-18', 'mb-0')}>5秒後自動跳轉，或 <Link to="/" className={cx('g-color-black', 'g-color-primary--hover', 'g-text-no-underline--hover')}>請點此回到首頁</Link></p>
                  </div>
                </div>
              </main>

            </section>
            {/* <!-- End main --> */}
          </div>
        </BasicLayout>
      </div>
    )
  }
}

export default PaymentSuccessPage


// WEBPACK FOOTER //
// ./src/pages/PaymentSuccessPage/index.tsx